export class THEME {
	public static readonly DARK = 'dark';
	public static readonly WHITE = 'white';
	public static readonly BLUE = 'blue';
}
